import wretch from 'wretch';

import { IItem } from '@xcritical/grid';

import { SSHelper } from '@crm-package/utils';

import {
  IChatData,
  IChat,
  IStorageToken,
  IGroupImportResponse,
} from '../types';
import { storageKeySelector } from '../store';

export async function getClientToken(
  clientId?: number
): Promise<IStorageToken> {
  const url = `/api/x-chat/token${clientId ? `?leadId=${clientId}` : ''}`;
  const { token, expiresIn, errorStatus, payload } =
    (await wretch(url).post().json<IStorageToken | null>()) || {};

  if (token && expiresIn) {
    SSHelper.setItem(storageKeySelector(clientId), {
      token,
      expiresIn,
      payload,
    });
  }

  return { token, expiresIn, errorStatus };
}

export async function getChats(token: string): Promise<IChatData> {
  return wretch('/api/xchat/chats').auth(`Bearer ${token}`).get().json();
}

export async function getCurrentChatData(
  token: string,
  id: number
): Promise<IChat> {
  return wretch(`/api/xchat/chats/${id}`).auth(`Bearer ${token}`).get().json();
}

export async function searchChat(
  userid: number,
  token: string
): Promise<IChatData> {
  return wretch('/api/xchat/search')
    .auth(`Bearer ${token}`)
    .post({ userid })
    .json();
}

export async function updateChats(
  token: string,
  lastMessageId: number
): Promise<IChatData> {
  return wretch(`/api/xchat/updates?lastMessageId=${lastMessageId}`)
    .auth(`Bearer ${token}`)
    .get()
    .json();
}

export async function updateChat(
  token: string,
  lastMessageId: number,
  chatId: number
): Promise<IChat> {
  return wretch(
    `/api/xchat/updates/chat/${chatId}?lastMessageId=${lastMessageId}`
  )
    .auth(`Bearer ${token}`)
    .get()
    .json();
}

export async function apiSendIdsForGroupImport(
  clients: IItem[],
  uniqueEnvironments: number[],
  token: string
): Promise<IGroupImportResponse[]> {
  return wretch(`/api/xchat/group-import`)
    .auth(`Bearer ${token}`)
    .post({ clients, uniqueEnvironments })
    .json();
}
